<template>
  <div class="HomePage w-full h-full">
    <div
      class="bg w-full h-20 flex justify-center items-center font-bold text-4xl"
    >
      PATHMMU BENCHMARK
    </div>
    <div class="PageContent flex justify-center items-center flex-col">
      <!-- overview -->
      <!-- <div class="headtitle text-3xl font-bold p-5">Overview</div> -->
      <div class="overview_content w-7/12">
        <!-- <div class="text-justify">
          占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符占位符v
        </div> -->
        <!-- <img
          src="resources/img/figures/overall.png"
          class="pt-10 pb-10"
          alt=""
        /> -->
      </div>
    </div>
    <!-- Feature -->
    <div class="w-7/12 pt-10 pb-5" style="margin: 0 auto">
      <div class="FeatureTitle">Key Features</div>
      <div class="FeatureContent grid grid-cols-3 gap-10">
        <div>
          <div class="SubTitle">Comprehensive and Specialized Data</div>
          <div class="subContent pt-5 text-justify">
            The dataset is compiled from various authoritative sources, with
            manual review by medical professionals to ensure it adheres to
            professional standards.
          </div>
        </div>
        <div>
          <div class="SubTitle">Effective and Valuable Questions</div>
          <div class="subContent pt-5 text-justify">
            The questions in the dataset are intricately designed to require
            answers based on the observation of pathology images, ensuring they
            are answerable and meet the standards of professional pathology
            exams.
          </div>
        </div>
        <div>
          <div class="SubTitle">Large-Scale</div>
          <div class="subContent pt-5 text-justify">
            The dataset contains 24,067 images and 33,428 multimodal
            multiple-choice questions from various sources, making it the
            largest pathology dataset currently available.
          </div>
        </div>
        <div>
          <div class="SubTitle">High-Quality Images</div>
          <div class="subContent pt-5 text-justify">
            The images in this dataset are sharp enough to discern every detail,
            with an average resolution of approximately 900 × 700 pixels.
          </div>
        </div>
        <div>
          <div class="SubTitle">Explainable Answer Choices</div>
          <div class="subContent pt-5 text-justify">
            The dataset provides a reference explanation of the answers and
            contributes to the interpretability of the model's decision-making
            process.
          </div>
        </div>
      </div>
    </div>
    <!-- Important Findings -->
    <div class="w-7/12 pt-10 pb-5" style="margin: 0 auto">
      <div class="text-2xl pb-3">Important Findings</div>
      <div class="flex items-center">
        <div
          class="w-2 h-2 bg-black mr-3"
          style="border-radius: 50%; min-width: 8px; min-height: 8px"
        ></div>
        <div>Current open-source LMMs struggle with the PathMMU.</div>
      </div>
      <div class="flex items-center pt-5">
        <div
          class="w-2 h-2 bg-black mr-3"
          style="border-radius: 50%; min-width: 8px; min-height: 8px"
        ></div>
        <div>
          While these LMMs show considerable robustness in robustness tests, the
          full extent of their robustness is still in question.
        </div>
      </div>
      <div class="flex items-center pt-5">
        <div
          class="w-2 h-2 bg-black mr-3"
          style="border-radius: 50%; min-width: 8px; min-height: 8px"
        ></div>
        <div>
          The text-only performance of GPT-4 Turbo surpasses the top-performing
          open-source LMMs on the PathMMU benchmark. We observe that GPT-4 Turbo
          sometimes takes shortcuts to guess answers.
        </div>
      </div>
      <div class="flex items-center pt-5">
        <div
          class="w-2 h-2 bg-black mr-3"
          style="border-radius: 50%; min-width: 8px; min-height: 8px"
        ></div>
        <div>
          Fine-tuning general-purpose LMMs with substantial amounts of data
          significantly boosts their ability to comprehend and reason with
          pathological images.
        </div>
      </div>
    </div>
    <!-- Latest news -->
    <div class="w-7/12 pt-10 pb-5" style="margin: 0 auto">
      <div class="font-bold text-red-500 text-2xl pb-3">Latest News</div>
      <!-- Top one -->
      <!--
      <div class="flex items-center">
        <div
          class="rounded-full h-2 w-2 bg-black mr-2"
          style="min-width: 8px; min-height: 8px"
        ></div>
        <div>
          <strong>[Important Notes!!!]</strong> As suggested by numerous
          researchers, exposing the answers to the test set of PathMMU can lead
          to data contamination. This happens when the test set from PathMMU is
          used for pretraining or fine-tuning other models, which can affect the
          fairness of evaluations. In light of this concern, we are currently
          developing an evaluation server. This server will enable users to
          submit results for automated evaluation, promoting a more equitable
          evaluation process. It specifically tackles the problem by keeping the
          answers confidential.
          <br />
          We will complete this evaluation process and update the dataset on
          Hugging Face by no later than <strong>February 6th, UTC-12</strong>.
          Furthermore, we will review all applications for data access to ensure
          they adhere to our terms.
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="rounded-full h-2 w-2 bg-black mr-2"
          style="min-width: 8px; min-height: 8px"
        ></div>
        <div>
          [2024.02.01] The benchmark
          <a
            href="https://huggingface.co/datasets/PathMMU/PathMMU"
            target="_blank"
            class="text-blue-500 border-b-2 border-blue-500"
            >data</a
          >
          has been released !!!
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="rounded-full h-2 w-2 bg-black mr-2"
          style="min-width: 8px; min-height: 8px"
        ></div>
        <div>
          [2024.01.31] We have released the
          <a
            href="https://github.com/PathMMU-Benchmark/PathMMU"
            target="_blank"
            class="text-blue-500 border-b-2 border-blue-500"
            >code</a
          >
          for evaluating LMMs on PathMMU !!!
        </div>
      </div>
      -->
      <div class="flex items-center">
        <div
          class="rounded-full h-2 w-2 bg-black mr-2"
          style="min-width: 8px; min-height: 8px"
        ></div>
        <div>
          The benchmark data and evaluation code have been released (8/7/2024).
        </div>
      </div>
    </div>
    <!-- publication -->
    <!-- <div class="w-7/12 pt-10 pb-5" style="margin: 0 auto">
      <div class="text-2xl pb-3">Publications</div>
      <div class="flex items-center">
        <img src="resources/img/figures/publication.png" alt="" />
        <div class="pl-5">
          <div class="intro">
            GOT-10k: A Large High-Diversity Benchmark for Generic Object
            Tracking in the Wild. L. Huang*, X. Zhao*, and K. Huang. ( *Equal
            contribution) IEEE Transactions on Pattern Analysis and Machine
            Intelligence (TPAMI).
          </div>
          <div class="link">
            <a href="" class="text-blue-600">[PDF] </a>
            <a href="" class="text-blue-600">[ArXiv]</a>
            <a href="" class="text-blue-600">[BibTex]</a>
          </div>
        </div>
      </div>
      <div class="text-gray-500 pt-5">
        <i>Please cite this paper if GOT-10k helps your research.</i>
      </div>
    </div> -->

    <!-- Comparisons  -->
    <div class="PageContent flex justify-center items-center flex-col pt-10">
      <!-- overview -->
      <div class="headtitle text-3xl font-bold p-5">
        Comparisons with Existing Benchmarks
      </div>
      <div class="overview_content md:w-7/12 w-10/12">
        <img
          src="resources/img/figures/data_comparison.png"
          class="pt-10 pb-2"
          alt=""
        />
        <div class="pb-10 pt-5 text-justify">
          <!--
          Given the current situation of limited and low-quality benchmarks in
          the pathology domain, we are motivated to develop a high-quality,
          expert-verified pathology benchmark from multiple sources. Compared
          with others, PathMMU is the largest, with 33573 Q&A and 21599 images.
          Our approach involves generating Q&As based on a wide range of
          image-caption pairs, followed by rigorous expert review and filtering
          of both the images and the generated questions. Additionally, we
          provide detailed explanations for each question's answer while others
          do not. Consequently, PathMMU stands out in the pathology domain for
          its professionalism and the quality of its questions, significantly
          advancing and validating the development of large pathology models.
          Figure above provides a detailed comparison of PathMMU with existing
          benchmarks.
          -->
          Given the current situation of limited and low-quality benchmarks in
          the pathology domain, we develop PathMMU, a large-scale, high-quality,
          and expert-verified pathology benchmark, to fill this gap. Our
          approach encompasses the generation of Q&As derived from a diverse
          range of image-caption pairs, with subsequent rigorous expert review
          and filtering applied to both the images and the questions. Moreover,
          we provide detailed explanations for each answer as a reference to
          enhance the interpretability of answers, which is absent in previous
          works. As shown in Figure above, PathMMU distinguishes itself in the
          pathology domain through its professionalism and superior quality.
        </div>
      </div>
    </div>
    <!-- methodology -->
    <div class="w-7/12 pb-20" style="margin: 0 auto">
      <div class="text-3xl font-bold p-5 text-center">Methodology</div>
      <div class="flex items-center">
        <img src="resources/img/figures/question_generation.jpg" alt="" />
      </div>
      <div class="mt-5">
        To guarantee the quality of our benchmark, we meticulously develop a
        three-step data processing and generation protocol. The overall data
        collection and generation process is illustrated in Figure above.
        <br /><br />
        <strong>Step 1: Data Collection and Preprocessing.</strong><br />

        Our data collection draws from a wide variety of sources, which we
        integrate as subsets into the PathMMU framework. These subsets are named
        PubMed, EduContent, Atlas, SocailPath, PathCLS. The critical step in the
        workflow is thorough manual review and filtering to ensure the high
        quality of more than 30,000 image-text pairs, forming the foundation of
        the PathMMU. <br />

        <strong
          >Step 2: Detailed Description Generation and Question-answer Pairs
          Generation.</strong
        >
        <br />
        Given that the correlation between some sources' images and their
        accompanying captions is often weak. For instance, in the SocialPath
        subset, captions might only describe the aesthetic appeal of the image,
        which is irrelevant to pathological findings. Similarly, in other data
        sources, captions tend to describe only a fraction of the features
        present in the image. To tackle this issue, we prompt GPT-4V to focus on
        describing the morphology of cells and tissues. It is crucial to note
        that merely prompting GPT-4V to output image descriptions might lead to
        incoherent content. Therefore, we provide GPT-4V with original captions
        for reference, significantly reducing the incidence of such occurrences
        and thus ensuring the generation of more precise and relevant
        descriptions.
        <br />
        <strong>Step 3: Question Generation and Expert Validation.</strong
        ><br />
        Following the generation of image descriptions, GPT-4V is tasked with
        creating three questions per image, each accompanied by multiple-choice
        options, the correct answer, and detailed explanations for the answer.
        The creation of these explanations serves a dual purpose: it not only
        offers valuable insights into the model reasoning process, but also
        facilitates the subsequent manual review phase.
        <br /><br />
        It's crucial to note that despite the careful design of question
        generation prompts for GPT-4V, the text-only GPT-4 is capable of
        correctly answering over 60% of these questions through educated
        guesses, bypassing the need for visual cues. GPT-4 explains that its
        deductions are drawn from patterns such as one option being more common
        in typical pathological scenarios or exhibiting noticeable differences
        from other options. We delve deeper into this phenomenon in Sec. 4.3 to
        offer a more thorough experimental analysis. To ensure that LMMs do not
        rely on educated guesses, thereby obscuring their true multimodal
        capabilities, we employ GPT3.5 Turbo, GPT-4 Turbo, Gemini Pro, and
        ERNIE-Bot-4 to perform educated guesses. Questions that at least three
        of these models correctly guess the answer are subsequently excluded.<br />
        <br />
        After thorough expert review, we obtain 710 Q&As accompanied by 510
        images for the validation set, and 9,677 Q&As with 7,213 images for the
        test set. Additionally, to establish a standard for expert performance,
        we extract a smaller subset from the test set, named 'test-tiny', which
        includes 1,156 Q&As. We invite two groups of professional pathologists
        to participate in this subset as an examination, and we average their
        performance to set a benchmark for expert performance in the PathMMU,
        serving as a comparison reference for LMMs.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
}
.FeatureTitle {
  color: #6f6e6e;
  font-size: 27px;
}
.SubTitle {
  color: #6f6e6e;
  margin-top: 20px;
  font-size: 20px;
}
.subContent {
  font-size: 16px;
  color: #6f6e6e;
}
</style>
